window.Products.HomeDecor.DuvetCoverFull = function() {};
window.Products.HomeDecor.DuvetCoverFull.inherits(window.Products.HomeDecor.DuvetCover);
window.Products.HomeDecor.DuvetCoverFull.has_3d = true;
window.Products.HomeDecor.DuvetCoverFull.id = '86-full';
window.Products.HomeDecor.DuvetCoverFull.saveId = 86;
window.Products.HomeDecor.DuvetCoverFull.slug = 'duvet-cover-full';
window.Products.HomeDecor.DuvetCoverFull.dpi = 150;
window.Products.HomeDecor.DuvetCoverFull.prototype.designObject = 1;